var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.headerState)?_c('app-header',{attrs:{"hideTitle":!_vm.titleState}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Nearby")])]):_vm._e(),_c('v-main',[_c('SearchResultList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }